import { createContext, type ReactNode } from "react";

export const PlatformOptionsCardContext = createContext(false);

type PlatformOptionsCardProps = {
  title: string;
  iconClassName: string;
  children: ReactNode;
};

export const PlatformOptionsCard = ({
  title,
  iconClassName,
  children,
}: PlatformOptionsCardProps) => (
  <PlatformOptionsCardContext.Provider value>
    <section
      className="mb-4 flex flex-col gap-4 rounded-lg border border-solid border-[#e6e6e6] p-4 [&_button[role=combobox]]:h-8 [&_button[role=combobox]]:py-1.5"
      data-testid={`platform-options-${title.toLowerCase().replaceAll(" ", "-")}`}
    >
      <div className="flex items-center gap-2 font-inter text-sm font-semibold leading-5 text-[#333]">
        <i
          className={`inline-flex size-4 items-center justify-center ${iconClassName}`}
          aria-hidden="true"
        />
        {title}
      </div>
      {children}
    </section>
  </PlatformOptionsCardContext.Provider>
);
